var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { BaseProvider } from './base';
import { UserProvider } from './user';
import { API } from './api';
import { NumberProvider } from './number';
import * as StringUtils from '../utils/string';
import { TranslateService } from '@ngx-translate/core';
var APIUsageProvider = /** @class */ (function (_super) {
    __extends(APIUsageProvider, _super);
    function APIUsageProvider(userProvider, numberProvider, api, translate) {
        var _this = _super.call(this) || this;
        _this.userProvider = userProvider;
        _this.numberProvider = numberProvider;
        _this.api = api;
        _this.translate = translate;
        _this.dataLoaded = false;
        return _this;
    }
    APIUsageProvider.prototype.load = function (force) {
        if (force === void 0) { force = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userProvider.load(force)];
                    case 1:
                        _a.sent();
                        this.userData = this.userProvider.getUserInformation();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    APIUsageProvider.prototype.parseUsageStatData = function (usedKey, limitKey, unit) {
        var usageStat = {
            used: this.userData.usageStatsTotals[usedKey],
            unlimited: this.userData.usageStatsLimits[limitKey] == -1 ? true : false,
            showLimit: true
        };
        if (unit != undefined) {
            usageStat.unit = unit;
        }
        if (!usageStat.unlimited) {
            usageStat.limit = this.numberProvider.round(this.userData.usageStatsLimits[limitKey], 2);
        }
        return usageStat;
    };
    APIUsageProvider.prototype.getStorageUsage = function () {
        return this.parseUsageStatData('diskSpace', 'Max Storage In GB', 'GB');
    };
    APIUsageProvider.prototype.getOrgUsersUsage = function () {
        return this.parseUsageStatData('usersInOrganization', 'Max Active Users');
    };
    APIUsageProvider.prototype.getBrainsUsage = function () {
        return this.parseUsageStatData('publishedBrains', 'Max Published Brains');
    };
    APIUsageProvider.prototype.getAPICallsUsage = function () {
        return this.parseUsageStatData('apiCalls', 'Max API Inferences Per Month');
    };
    /**
     *  Take information about an estimate (API usage, or time remaining), and return a pretty-printed value.
     * @param data The number we want to format.
     * @param unit The unit (if any) we want to attach to the formatted value.
     * @param precision The amount of rounding (if any) we should perform on the data.
     * @param longForm For time formatting, whether or not we want to use verbose time unit names.
     */
    APIUsageProvider.prototype.formatUsageUnit = function (data, unit, precision, longForm) {
        if (precision === void 0) { precision = 2; }
        if (longForm === void 0) { longForm = false; }
        var formatedDataWithUnit = {
            data: '',
            unit: ''
        };
        switch (unit) {
            case undefined:
                formatedDataWithUnit = {
                    data: "" + this.numberProvider.getCommaDelineatedNumStr(this.numberProvider.round(data, 2)),
                    unit: ''
                };
                break;
            case 'hr':
                formatedDataWithUnit = this.formatHourUnits(data);
                break;
            case 'sec':
                formatedDataWithUnit = this.formatSecondUnits(data, precision, longForm);
                break;
            default:
                formatedDataWithUnit = {
                    data: "" + this.numberProvider.getCommaDelineatedNumStr(this.numberProvider.round(data, 2)),
                    unit: unit
                };
                break;
        }
        return formatedDataWithUnit.data + " " + formatedDataWithUnit.unit;
    };
    APIUsageProvider.prototype.formatHourUnits = function (data) {
        var formattedData;
        if (data === null || data == undefined) {
            return {
                data: '0',
                unit: 'hr'
            };
        }
        if (data < 1) {
            formattedData = {
                data: "" + this.numberProvider.getCommaDelineatedNumStr(this.numberProvider.round(data * 60, 2)),
                unit: 'min'
            };
        }
        else if (data * 60 < 1) {
            formattedData = {
                data: "" + this.numberProvider.getCommaDelineatedNumStr(this.numberProvider.round(data * 3600, 2)),
                unit: 'sec'
            };
        }
        else {
            formattedData = {
                data: "" + this.numberProvider.getCommaDelineatedNumStr(this.numberProvider.round(data, 2)),
                unit: 'hr'
            };
        }
        return formattedData;
    };
    APIUsageProvider.prototype.formatSecondUnits = function (data, precision, longForm) {
        if (precision === void 0) { precision = 2; }
        var formattedData;
        if (data === null || data == undefined) {
            return {
                data: '0',
                unit: 'sec'
            };
        }
        if (data < 60) {
            formattedData = {
                data: "" + this.numberProvider.getCommaDelineatedNumStr(this.numberProvider.round(data, precision)),
                unit: longForm
                    ? data === 1
                        ? this.translate.instant('Second').toLowerCase()
                        : this.translate.instant('Seconds').toLowerCase()
                    : this.translate.instant('Sec').toLowerCase()
            };
        }
        else if (data >= 60 && data < 3600) {
            var timeInMinutes = this.numberProvider.round(data / 60, precision);
            formattedData = {
                data: "" + this.numberProvider.getCommaDelineatedNumStr(this.numberProvider.round(data / 60, precision)),
                unit: longForm
                    ? timeInMinutes === 1
                        ? this.translate.instant('Minute').toLowerCase()
                        : this.translate.instant('Minutes').toLowerCase()
                    : this.translate.instant('Min').toLowerCase()
            };
        }
        else {
            var timeInHours = this.numberProvider.round(data / 60, precision);
            formattedData = {
                data: "" + this.numberProvider.getCommaDelineatedNumStr(this.numberProvider.round(data / 3600, precision)),
                unit: longForm
                    ? timeInHours === 1
                        ? this.translate.instant('Hour').toLowerCase()
                        : this.translate.instant('Hours').toLowerCase()
                    : this.translate.instant('HR').toLowerCase()
            };
        }
        return formattedData;
    };
    APIUsageProvider.prototype.getInferenceStatsForCurrentBillingPeriod = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var now, endOfBillingPeriod, startOfBillingPeriod;
            return __generator(this, function (_a) {
                now = new Date(Date.now());
                endOfBillingPeriod = new Date(now);
                endOfBillingPeriod.setMonth(now.getMonth() + 1);
                endOfBillingPeriod.setDate(0);
                startOfBillingPeriod = new Date(now);
                startOfBillingPeriod.setDate(1);
                return [2 /*return*/, this.api
                        .get("inferences/stats?aggregationType=day&dateTo=" + this.getStrFromDateObj(endOfBillingPeriod) + "&dateFrom=" + this.getStrFromDateObj(startOfBillingPeriod))
                        .then(function (_a) {
                        var success = _a.success, message = _a.message;
                        if (success) {
                            var translateReplacements_1 = {
                                month: now.toLocaleString('en-us', { month: 'long' })
                            };
                            return message.map(function (result) {
                                return __assign({}, result, { checked: false, name: _this.translate.instant('Activity for the month of [[month]]', translateReplacements_1) });
                            });
                        }
                    })];
            });
        });
    };
    APIUsageProvider.prototype.getAllActivityForGivenPeriod = function (_a) {
        var dateFrom = _a.dateFrom, dateTo = _a.dateTo, aggType = _a.aggType;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var urlSlug;
            return __generator(this, function (_b) {
                urlSlug = "inferences/stats?aggregationType=" + aggType + "&dateTo=" + dateTo + "&dateFrom=" + dateFrom;
                return [2 /*return*/, this.api.get(urlSlug).then(function (_a) {
                        var success = _a.success, message = _a.message;
                        if (success) {
                            return message.map(function (result) {
                                return __assign({}, result, { name: _this.translate.instant('All Activity') });
                            });
                        }
                    })];
            });
        });
    };
    APIUsageProvider.prototype.getEnvironmentActivityForGivenDataset = function (id, aggType, dateTo, dateFrom) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api
                        .get("inferences/stats?aggregationType=" + aggType + "&dateTo=" + dateTo + "&dateFrom=" + dateFrom + "&data[0][brainIdentifier]=" + id + "&data[0][environment]=staging&data[1][brainIdentifier]=" + id + "&data[1][environment]=production")
                        .then(function (_a) {
                        var success = _a.success, message = _a.message;
                        if (success) {
                            return message.map(function (result) {
                                return __assign({}, result, { name: StringUtils.capitalizeFirstLetter(result.inferenceInfo.environment) });
                            });
                        }
                    })];
            });
        });
    };
    APIUsageProvider.prototype.getStrFromDateObj = function (date) {
        var yearStr = date.getFullYear();
        var monthStr = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : "" + (date.getMonth() + 1);
        var dayStr = date.getDate() + 1 < 10 ? "0" + date.getDate() : "" + date.getDate();
        return yearStr + "-" + monthStr + "-" + dayStr;
    };
    APIUsageProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [UserProvider,
            NumberProvider,
            API,
            TranslateService])
    ], APIUsageProvider);
    return APIUsageProvider;
}(BaseProvider));
export { APIUsageProvider };
//# sourceMappingURL=api_usage.js.map


// WEBPACK FOOTER //
// ./src/providers/api_usage.ts.pre-build-optimizer.js